module.exports = __webpack_public_path__ + "static/img/wxpcr.6ef9679.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/wxpcr.png
// module id = uxxZ
// module chunks = 0